import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { AdService } from './ad.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-ad',
  templateUrl: './ad.component.html',
})

export class AdComponent {

  ad: any = {};
  options: any;
  file: any;
  isLoading: any;
  id: string;
  adForm!: FormGroup;
  config: any;
  operation: string;
  selectedSale: any;
  banks: any;
  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  sales: any[];
  ads: any[];
  awards: any[];
  ekubMembers: any[];

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private api: AdService, private router: Router,
    @Inject(Restangular) public Restangular) {
    /*  this.ad = {
       'bank': '',
       'position': 0,
       'remark': ''
     }; */
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.filter = '';
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
    }
    this.operation = 'add';
    this.banks = [{ name: 'Bank Of Abyssinia', accronym: 'BOA' },
    { name: 'Commercial Bank of Ethiopia', accronym: 'CBE' }]
  }

  get ad_number() { return this.adForm.get('ad_number'); }
  get bank() { return this.adForm.get('bank'); }
  get accronym() { return this.adForm.get('accronym'); }
  get status() { return this.adForm.get('status'); }
  get remark() { return this.adForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getAds();
  }

  getclientAds(ekubId: any) {
    debugger;
    this.api.getClientAds(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        if (this.selectedSale) {
          var index = this.ekubMembers.map(x => {
            return x.id;
          }).indexOf(this.selectedSale.award.data.winner.data.id);
          this.ekubMembers.splice(index, 1);
        }
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }



  getAds() {
    debugger;
    this.api.getAds(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.ads = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {

    this.adForm = this.formBuilder.group({
      ad_number: ['', [Validators.required,]],
      accronym: ['', [Validators.required]],
      bank: ['', [Validators.required]],
      status: ['pending', [Validators.required]],
      remark: [''],
    });
  }

  getAd() {
    this.api.getAd(this.id).subscribe((res: any) => {
      debugger;
      this.ad = res.data;
      this.adForm.setValue(res.data);
    });
  }
 

  changeStatus(id: any, status: any) {
    this.api.changeAdStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getAds();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  addAd() {
    debugger;
    this.isLoading = !this.isLoading;
    var id = this.ad.id;
    this.bank.setValue(this.bank.value.name);
    this.ad = this.adForm.value;
    this.api.createAd({ ad: this.ad }, id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.adForm.reset();
      this.getAds();
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Ad successfully updated! ' : 'Ad  successfully added!', type: 'dark' });
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update ad!' : 'Could not add ad!', type: 'danger' });
    });
  }

  reset() {
    debugger;
    this.operation = 'add';
    this.adForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getAds();
  }

  editAd(ad: any) {
    debugger;
    this.ad = ad;
    this.adForm.get('ad_number').setValue(ad.ad_number);
    this.adForm.get('accronym').setValue(ad.accronym);
    this.adForm.get('bank').setValue(ad.bank);
    this.adForm.get('status').setValue(ad.status);
    this.adForm.get('remark').setValue(ad.remark);
    this.operation = 'update';
  }

}
